import React from "react";
import "./Option.css";

type props = {
  title: string;
  image: string;
  onClick: () => void;
};

export const Option: React.FC<props> = ({ title, image, onClick }) => {
  return (
    <div onClick={onClick} className="option-container">
      <img src={image} alt="" className="option-image" />
      <span className="option-text">{title}</span>
    </div>
  );
};
